import Scrollbars from "react-custom-scrollbars"
import styled from "styled-components"

export const List = styled.ul`
    width: 98%;
    flex-wrap: wrap;
    justify-content: space-between;
    display: flex;

    >li{
        margin: 1% 1%;
        padding: .9rem;
        min-width: 200px;
        width: calc((100% / 5) - 2%);
        display:flex;
        flex-flow: column;
        height: fit-content;
        align-items: flex-start;
        color: ${({theme}) => theme.container.primary.text};
        box-shadow: ${({theme}) => theme.container.primary.boxShadow};
        border: ${({theme}) => theme.container.primary.border};
        background: ${({theme}) => theme.container.primary.background};
        border-radius: ${({theme}) => theme.container.primary.borderRadius};

        &:hover {
            background: ${({theme}) => theme.button.secondary.hover.background};
        }
        
        &.tab_positive{> div.title p{color: #4DBCAC;}}
        &.tab_neutral{> div.title p{color: #FF8500;}}
        &.tab_negative{> div.title p{color: #EC3EA2;}}
        
        >div.title {
            width: 100%;
            display: flex;
            justify-content: space-between;
            
            p {
                max-width: 80%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                color: ${({theme}) => theme.primary};
                font-weight: bold;
                display: flex;
                align-items: center;
                
                span {
                    color: white;
                    font-size: 1rem;
                    min-height: 2rem;
                    color: ${({theme}) => theme.primary};
                    display: inline-block;
                    min-width: 2rem;
                    text-align: center;
                    border-radius: 50%;
                    margin-right: .5rem;
                    line-height: 200%;
                }
            }
        }
        
        div.active,div.inactive,div.dept{
            color: #FFF;
            padding: .25rem;
            font-size: .65rem;
            border-radius: 4px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 40px;
            display: flex;
            align-items: center;
        }

        div.dept{
            background-color: #5739EA;  
        }

        div.active{
            background-color: #43a047;
        }

        div.inactive{
            background-color: #E15030;
        }

        >p {
            min-height: fit-content;
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color:#212121;
            margin-top: .25rem;
        }
    }   
`

export const Scrollbar = styled(Scrollbars)`
    margin-top:27px;
    
    >div:nth-child(3):not(.bar){
        height: 60%;
        margin: auto 0;
        background-color: transparent;
    }

    >div:first-child{
        margin-right:-16px!important;
    }

    >div:nth-child(3) > div{
        background-color: ${({theme}) => theme.scroll}!important;
        opacity: .8;
    }
    
    >div:nth-child(2) {
        display: none;
    }
`